<app-admin-dashboard>
  <p-card header="{{ 'HomeHeader.AdminMenu.AssignedDocumentsReport' | translate }}">
    <form [formGroup]="form">
      <div class="p-fluid formgrid mr-2 ml-2 grid">
        <div class="field col-6">
          <label for="exporterId" style="font-weight: bolder">Exportador *</label>
          <p-dropdown
            id="exporterId"
            formControlName="exporterId"
            [options]="exporters"
            optionValue="id"
            optionLabel="companyName"
            [filter]="true"
            filterBy="companyName"
            [showClear]="false"
            placeholder="Exportador"
          >
          </p-dropdown>
        </div>
      </div>
      <div class="p-fluid formgrid mr-2 ml-2 grid">
        <div class="field col-3">
          <label for="startDate" style="font-weight: bolder">Fecha inicial *</label>
          <p-calendar
            inputId="startDate"
            formControlName="startDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [minDate]="minStartDate!"
            [maxDate]="maxStartDate!"
            (onSelect)="onStartDateChange()"
            (onClearClick)="onStartDateChange()"
            placeholder="dd/mm/aaaa"
          >
          </p-calendar>
        </div>
        <div class="field col-3">
          <label for="endDate" style="font-weight: bolder">Fecha final *</label>
          <p-calendar
            inputId="endDate"
            formControlName="endDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [minDate]="minEndDate!"
            [maxDate]="maxEndDate!"
            (onSelect)="onEndDateChange()"
            (onClearClick)="onEndDateChange()"
            placeholder="dd/mm/aaaa"
          >
          </p-calendar>
        </div>
      </div>
    </form>
    <div class="p-fluid formgrid mr-2 ml-2 grid">
      <div class="col-3">
        <p-button
          type="button"
          (click)="downloadReport()"
          [loading]="loadingBtnDownload"
          [disabled]="form.invalid"
          [style]="{ width: 'fit-content' }"
        >
          {{ "MessageService.AssignedDocumentsReport.ExportButton" | translate }}
        </p-button>
      </div>
    </div>
  </p-card>
</app-admin-dashboard>
